module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [(_vm.isActive) ? _c('div', {
    staticClass: "system-builder__notification",
    style: ({
      border: '3px solid ' + _vm.notificationColor
    }),
    on: {
      "click": function($event) {
        {
          _vm.$emit('closeNotification')
        }
      }
    }
  }, [_c('div', {
    staticClass: "system-builder__notification--content"
  }, [_vm._t("notification-body"), _vm._v(" "), _c('span', {
    staticClass: "system-builder__notification--close",
    on: {
      "click": _vm.closeNotification
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle-o",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 2)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d2ee555","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reusable/notification.vue
// module id = 415
// module chunks = 1